<template lang="html">
<div class="scrolling-table">
    <div class="no-data grey lighten-2 grey--text" v-if="!hasData">
        <span>No data available</span>
    </div>

    <div class="header-wrap" v-if="hasData">
        <!-- top (static) corner: cel 0 of row 0 -->
        <div class="cell header-cell top-corner">
            {{ data[0][0].text }}
        </div>

        <scroll-sync horizontal class="headers">
            <div v-for="th in paginatedData[0]" :key="th.text" class="cell header-cell" v-text="th.text">
            </div><div class="spacer cell header-cell">&nbsp;</div>
        </scroll-sync>
    </div>

    <div class="scrolling-table-wrap" v-if="hasData">

        <scroll-sync class="left-column" vertical horizontal>
            <div class="cell" v-for="row, i in paginatedData" :key="row[0].text" v-if="i > 0">
                {{ row[0].text }}
            </div>
            <div v-show="data.length > yCount" style="margin-top: 36px;">&nbsp;</div>
            <div class="spacer cell">&nbsp;</div>
        </scroll-sync>

        <scroll-sync class="scroll-wrap main">
            <table class="table">
                <tr v-for="row, rowIndex in paginatedData" v-if="rowIndex > 0">
                    <td
                    class="cell"
                    :style="cellStyle(td)"
                    v-for="td, tdIndex in row" v-if="tdIndex > 0"
                    >
                        <div
                        class="tabel-cell-inner"
                        v-html="(td.text || td.text === 0) ? td.text : '&nbsp;'">
                        </div>
                    </td>
                </tr>
            </table>
        </scroll-sync>

    </div>
    <v-btn v-if="data.length > yCount" style="margin-left: 170px;" @click="loadMoreY">Load More</v-btn>

</div>
</template>

<script>
import ScrollSync from 'vue-scroll-sync';

export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            yCount: 15,
            busy: false,
        };
    },
    components: {
        ScrollSync,
    },
    computed: {
        paginatedData() {
            if (this.data.length <= this.yCount) {
                return this.data;
            }
            return this.data.slice(0, this.yCount);
        },
        hasData() {
            if (this.data.length > 0 && this.data[0].length > 0) {
                return true;
            }

            return false;
        },
    },
    updated() {
        this.resizeHeaderCells();
    },
    mounted() {
        // resize header cells on window resize
        window.addEventListener('resize', this.resizeHeaderCells());

        // resize header cells after the table's initial render
        this.$nextTick(() => {
            this.resizeHeaderCells();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHeaderCells());
    },
    methods: {
        loadMoreY() {
            this.yCount += 15;
        },
        cellStyle(cell) {
            const styles = {};
            if (cell.color) {
                styles.backgroundColor = cell.color;
            }
            return styles;
        },
        resizeHeaderCells() {
            if (!this.hasData) {
                return;
            }

            // reset anything already resized
            const resizedCells = Array.from(this.$el.querySelectorAll('.scrolling-table-resized'));
            resizedCells.forEach((el) => {
                el.style.removeProperty('width');
                el.style.removeProperty('height');
                el.classList.remove('scrolling-table-resized');
            });

            const leftCol = this.$el.querySelector('.left-column');
            const tableRows = this.$el.querySelectorAll('.table tr');

            // resize header "columns"
            const firstTableRow = tableRows[0];
            const firstTableRowCells = firstTableRow.querySelectorAll('td');
            const headerRow = Array.from(this.$el.querySelectorAll('.headers > .cell:not(.spacer)'));
            headerRow.forEach((td, i) => {
                // resize left column header
                if (i === 0) {
                    const colWidth = leftCol.offsetWidth;
                    td.style.width = `${colWidth}px`;
                    return;
                }

                const tableCell = firstTableRowCells[i - 1];
                const colWidth = tableCell.offsetWidth;
                const headerWidth = td.offsetWidth;
                // resize the column or the header cell, depending on which is wider
                if (colWidth > headerWidth) {
                    // add !importantt because ie gives incorrect prcedence to the stylesheet over the inline styles
                    td.classList.add('scrolling-table-resized');
                    td.style.width = `${colWidth}px`;
                } else if (colWidth < headerWidth) {
                    // add !importantt because ie gives incorrect prcedence to the stylesheet over the inline styles
                    tableCell.classList.add('scrolling-table-resized');
                    tableCell.querySelector('.tabel-cell-inner').style.width = `${headerWidth}px`;
                }
            });

            // resize left column "rows"
            const leftColCells = Array.from(leftCol.querySelectorAll('.cell:not(.spacer)'));
            leftColCells.forEach((tr, i) => {
                const tableRow = tableRows[i];
                const rowHeight = tableRow.offsetHeight;
                const leftCellHeight = tr.offsetHeight;
                // resize the row or left col cell depending on which is taller
                if (rowHeight > leftCellHeight) {
                    tr.classList.add('scrolling-table-resized');
                    tr.style.height = `${rowHeight}px`;
                } else if (rowHeight < leftCellHeight) {
                    tableRow.classList.add('scrolling-table-resized');
                    tableRow.style.height = `${leftCellHeight}px`;
                }
            });

            const topCorner = this.$el.querySelector('.top-corner');
            topCorner.classList.add('scrolling-table-resized');
            topCorner.style.width = `${leftColCells[0].offsetWidth}px`;
            topCorner.style.height = `${headerRow[0].offsetHeight}px`;
        },
    },
};
</script>

<style lang="scss">
.scrolling-table {
    width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    .cell {
        box-shadow: inset 1px -1px 0 rgba(107, 140, 158, .6);
    }

    .header-wrap {
        position: relative;
        flex: 0 0 auto;
        .top-corner.cell {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
            width: 100px;
        }
        .headers {
            overflow-x: hidden;
            white-space: nowrap;
        }

        .header-cell {
            padding: .5rem .75rem;
            background: #fff;
            display: inline-block;
        }

        // padding to accommodate the scrollbar
        // IE11 won't let us just use padding
        // so add a spacer cell
        .spacer {
            width: 30px;
        }
    }

    .scrolling-table-wrap {
        max-height: 100%;
        width: 100%;
        flex: 1 1 100%;
        display: flex;
        overflow: hidden;

        .left-column {
            overflow-y: hidden;
            max-width: 12rem;
            flex: 0 0 auto;
            // border-right: 1px solid #ccc;
            background: #fff;
            .cell {
                // white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: .5rem .75rem;
            }
            // padding to accommodate the scrollbar
            .spacer {
                height: 30px;
                box-shadow: none;
            }
        }
        .scroll-wrap.main {
            overflow: scroll;
            flex: 1 1 auto;
            .table {
                flex: 1 1 auto;
                td.cell {
                    min-width: 4rem;

                    // use an inner div to make dynamic sizing easier
                    div.tabel-cell-inner {
                        height: 100%;
                        padding: .5rem .5rem;
                        box-sizing: border-box;
                        width: 100%;
                    }
                }
            }
        }
    }

    .no-data {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollingTable.vue